// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SponsorsPage {
    margin-top: 10vh;
}

.organizers-page {
    padding: 80px 20px;
    background-color: #f8f9fa;
    min-height: calc(100vh - 20vh);
}

.organizers-container {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
}

.organizers-title {
    color: #2c3e50;
    margin-bottom: 30px;
    font-size: 2rem;
}

.organizers-names {
    margin-bottom: 30px;
}

.organizers-names p {
    color: #555;
    line-height: 2;
    font-size: 1.1rem;
}

.organizers-names strong {
    color: #333;
}

.organizers-email {
    margin: 30px 0;
    font-size: 1.2rem;
}

.organizers-email a {
    color: #007bff;
    text-decoration: none;
}

.organizers-email a:hover {
    text-decoration: underline;
}

.logos-block {
    background: white;
    padding: 40px 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    margin: 40px auto;
    max-width: 900px;
}

.institutions-logos {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    flex-wrap: wrap;
}

.logo-with-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.institution-logo {
    height: auto;
    width: auto;
    object-fit: contain;
    display: block;
}

.tandon-logo {
    max-height: 70px;
    max-width: 280px;
    filter: none;
}

.cmu-logo {
    max-height: 70px;
    max-width: 280px;
    filter: none;
}

.logo-text {
    font-size: 0.9rem;
    color: #666;
    margin: 0;
    font-style: italic;
    text-align: center;
}

.institutions {
    font-weight: bold;
    color: #333;
    margin-top: 30px;
    font-size: 1.1rem;
}

.partnership-section {
    text-align: center;
    margin: 20px 0;
    width: 100%;
}

.partnership-section h2 {
    margin-bottom: 20px;
}

.partnership-section iframe {
    border: none;
}

.sponsors-block {
    background: white;
    padding: 40px 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    margin: 30px auto;
    max-width: 900px;
    text-align: center;
}

.sponsors-title {
    color: #2c3e50;
    font-size: 1.6rem;
    margin-bottom: 25px;
}

.sponsors-logos {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    flex-wrap: wrap;
}

.sponsor-logo {
    max-height: 80px;
    max-width: 200px;
    object-fit: contain;
}

@media (max-width: 768px) {
    .institutions-logos {
        flex-direction: column;
        gap: 30px;
    }
    
    .organizers-title {
        font-size: 1.5rem;
    }

    .sponsors-logos {
        flex-direction: column;
        gap: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SponsorsPage/SponsorsPage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ","sourcesContent":[".SponsorsPage {\n    margin-top: 10vh;\n}\n\n.organizers-page {\n    padding: 80px 20px;\n    background-color: #f8f9fa;\n    min-height: calc(100vh - 20vh);\n}\n\n.organizers-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    text-align: center;\n}\n\n.organizers-title {\n    color: #2c3e50;\n    margin-bottom: 30px;\n    font-size: 2rem;\n}\n\n.organizers-names {\n    margin-bottom: 30px;\n}\n\n.organizers-names p {\n    color: #555;\n    line-height: 2;\n    font-size: 1.1rem;\n}\n\n.organizers-names strong {\n    color: #333;\n}\n\n.organizers-email {\n    margin: 30px 0;\n    font-size: 1.2rem;\n}\n\n.organizers-email a {\n    color: #007bff;\n    text-decoration: none;\n}\n\n.organizers-email a:hover {\n    text-decoration: underline;\n}\n\n.logos-block {\n    background: white;\n    padding: 40px 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n    margin: 40px auto;\n    max-width: 900px;\n}\n\n.institutions-logos {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 40px;\n    flex-wrap: wrap;\n}\n\n.logo-with-text {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n}\n\n.institution-logo {\n    height: auto;\n    width: auto;\n    object-fit: contain;\n    display: block;\n}\n\n.tandon-logo {\n    max-height: 70px;\n    max-width: 280px;\n    filter: none;\n}\n\n.cmu-logo {\n    max-height: 70px;\n    max-width: 280px;\n    filter: none;\n}\n\n.logo-text {\n    font-size: 0.9rem;\n    color: #666;\n    margin: 0;\n    font-style: italic;\n    text-align: center;\n}\n\n.institutions {\n    font-weight: bold;\n    color: #333;\n    margin-top: 30px;\n    font-size: 1.1rem;\n}\n\n.partnership-section {\n    text-align: center;\n    margin: 20px 0;\n    width: 100%;\n}\n\n.partnership-section h2 {\n    margin-bottom: 20px;\n}\n\n.partnership-section iframe {\n    border: none;\n}\n\n.sponsors-block {\n    background: white;\n    padding: 40px 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n    margin: 30px auto;\n    max-width: 900px;\n    text-align: center;\n}\n\n.sponsors-title {\n    color: #2c3e50;\n    font-size: 1.6rem;\n    margin-bottom: 25px;\n}\n\n.sponsors-logos {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 40px;\n    flex-wrap: wrap;\n}\n\n.sponsor-logo {\n    max-height: 80px;\n    max-width: 200px;\n    object-fit: contain;\n}\n\n@media (max-width: 768px) {\n    .institutions-logos {\n        flex-direction: column;\n        gap: 30px;\n    }\n    \n    .organizers-title {\n        font-size: 1.5rem;\n    }\n\n    .sponsors-logos {\n        flex-direction: column;\n        gap: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
